import { useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import {
  cleanBlacklistAnalyze,
  getBlacklistAnalyze
} from '../../../../../actions/blacklist'
import { behaviorNames, scopeNames } from '../../../../../main/blacklistHelpers'
import { ColumnFooter, ColumnWarning } from '../../../Column/index'
import LoadingIndicator from '../../../LoadingIndicator'
import MatchesDialog from '../../../MatchesDialog/index'
import BlacklistContext from '../../BlackListContext'
import DetailsColumn from '../../DetailsColumn/index'
import styles from './Confirmation.module.scss'

const Confirmation = () => {
  const [showingDetails, setShowingDetails] = useState(false)

  const { exclusions, conversion, lengths } = useContext(BlacklistContext)

  const dispatch = useDispatch()

  const { isAnalyzing, analyzeResults } = useSelector(s => s.blacklist)

  useEffect(() => {
    dispatch(
      getBlacklistAnalyze(exclusions, conversion.convertedSubscriberHotelBookingId)
    )
  }, [conversion.convertedSubscriberHotelBookingId, dispatch, exclusions])

  useEffect(() => {
    return () => dispatch(cleanBlacklistAnalyze())
  }, [dispatch])

  return (
    <>
      {isAnalyzing ? (
        <LoadingIndicator />
      ) : (
        exclusions.map(o => (
          <DetailsColumn
            key={o.requestCategory}
            name={o.requestCategory}
            conversion={conversion}
            lengths={lengths}
            isFullWidth={exclusions.length === 1}
          >
            <BehaviorAndScopeInfo object={o} />
            <ExclusionInfo
              requestCategory={o.requestCategory}
              analyzeResults={analyzeResults}
              handleClick={() => setShowingDetails(true)}
            />
          </DetailsColumn>
        ))
      )}
      {showingDetails && (
        <MatchesDialog
          matches={analyzeResults}
          handleClose={() => setShowingDetails(false)}
        />
      )}
    </>
  )
}

const BehaviorAndScopeInfo = ({ object }) => (
  <ul className={styles.behaviorAndScopeInfo}>
    <li>Behavior: {behaviorNames[object.behavior]}</li>
    <li>Scope: {scopeNames[object.scope]}</li>
  </ul>
)

const ExclusionInfo = ({ handleClick, analyzeResults, requestCategory }) => {
  const total =
    analyzeResults &&
    analyzeResults.categories &&
    analyzeResults.categories.find(
      cat => cat.category.toLowerCase() === requestCategory.toLowerCase()
    ) &&
    analyzeResults.categories.find(
      cat => cat.category.toLowerCase() === requestCategory.toLowerCase()
    ).totalConversionsEffected

  return (
    <>
      <ColumnFooter>
        <div className={styles.exclusionInfo}>
          <div className={styles.exclusionNumber}>
            {total || 0} conversions will be excluded
          </div>
          {total > 0 && <button onClick={handleClick}>See details</button>}
        </div>
      </ColumnFooter>
      {[
        'invitedEmailAddress',
        'invitedPhoneNumber',
        'invitedAddress',
        'invitedEmailDomain'
      ].includes(requestCategory) && (
        <ColumnWarning>
          Won't be immeditely excluded since exclusions are based on converted values.
        </ColumnWarning>
      )}
    </>
  )
}

export default Confirmation
